import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMain,[_c('router-view'),_c('bottom-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }